import { types } from "../../types/types";

const initialState = {
  items: [],
  itemsSeleccionado: [],
  infoConsultaAfiliado: [],
  cargada: false,
  loading: false,
  seleccionado: null,
  error: null,
};

export const facturasAfiliadoReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.facturasAfiliadoTraerStart:
          return {
            ...state,
            loading: true,
            error: null,
            cargada: false,
          };
        case types.facturasAfiliadoTraerSuccess:
          return {
            ...state,
            loading: false,
            items: action.payload,
            seleccionado: null,
            cargada: true,
          };
        case types.facturasAfiliadoTraerError:
          return {
            ...state,
            loading: false,
            error: action.payload,
            items: [],
            itemsSeleccionado: [],
            cargada: false,
          };
        case types.facturasAfiliadoLimpiar:
          return {
            items: [],
            itemsSeleccionado: [],
            loading: false,
            cargada: false,
          };
        case types.facturasAfiliadoModificar:
          return {
            ...state,
            loading: false,
            seleccionado: null,
            items: state.items.map( item => item.idFactura === action.payload.idFactura
              ? {...action.payload} 
              : item
            ),
          };  
        case types.facturasAfiliadoEliminar:
          return {
            ...state,
            loading: false,
            items: state.items.filter( item => item.idFactura !== action.payload ),
            cargada: true,
          };
        case types.facturasAfiliadoSeleccionado:
          return {
            ...state,
            loading: false,
            seleccionado: action.payload,
            cargada: true,
          };
        case types.facturasAfiliadoSeleccionadoLimpiar:
          return {
            ...state,
            loading: false,
            seleccionado: null,
            itemsSeleccionado: [], 
            cargada: true,
          };
        case types.facturasAfiliadoDetalleSeleccionadoTraerSuccess:
          return {
            ...state,
            loading: false,
            itemsSeleccionado: action.payload,
            cargada: true,
          };
        case types.facturasAfiliadoConsultaSuccess:
          return {
            ...state,
            infoConsultaAfiliado: action.payload,
          }
        case types.facturasAfiliadoConsultaError:
          return {
            ...state,
            infoConsultaAfiliado: [],
          }
        default:
          return state;
      }
    };
    